import api from '../httpClient';

export type MobilePreferences = {
  daily_checkin_enabled: boolean;
  meetings_enabled: boolean;
  recaps_enabled: boolean;
  reminder_time: string;
  quiet_start: string;
  quiet_end: string;
  timezone: string;
};
export type MobileStatus = { enabled: boolean; providers: { apns: boolean; fcm: boolean }; bridge_version: number; device_registered?: boolean; native_calls_enabled?: boolean };

export const mobileApi = {
  status: async (installationId?: string) => (await api.get<MobileStatus>('/api/mobile/status/', { params: installationId ? { installation_id: installationId } : undefined })).data,
  preferences: async () => (await api.get<MobilePreferences>('/api/mobile/preferences/')).data,
  updatePreferences: async (values: Partial<Omit<MobilePreferences, 'timezone'>>) => (
    await api.patch<MobilePreferences>('/api/mobile/preferences/', values)
  ).data,
  register: async (values: { installation_id: string; platform: 'ios' | 'android'; provider: 'apns' | 'fcm'; token: string }) => (
    await api.post('/api/mobile/devices/', values)
  ).data,
  unregister: async (installationId: string) => {
    await api.delete(`/api/mobile/devices/${encodeURIComponent(installationId)}/`);
  },
  testNotification: async (installationId: string, idempotencyKey = crypto.randomUUID()) => (
    await api.post<{ id: string; status: string; queued: boolean }>('/api/mobile/test-notification/', {
      installation_id: installationId, idempotency_key: idempotencyKey,
    })
  ).data,
};
